<template>
  <Navbar />
  <Landing />
  <v-container class="">
    <v-row>
      <v-col v-if="serviceTypeCards.length === 0 && !error" cols="12" class="my-10">
        <!-- <v-progress-circular indeterminate color="primary" size="50" class="mb-4" />
       -->
        <v-row>
          <v-col cols="12" md="6">
            <v-skeleton-loader class="mx-auto border" max-width="300" type="card-avatar, actions"></v-skeleton-loader>
          </v-col>

          <v-col cols="12" md="6">
            <v-skeleton-loader class="mx-auto border" max-width="300" type="image, article"></v-skeleton-loader>
          </v-col>
        </v-row>
        <p>Loading services, please wait...</p>
      </v-col>

      <v-col v-if="error" cols="12" class="text-center my-10">
        <v-alert type="error" border="left" colored-border>
          {{ error }}
        </v-alert>
      </v-col>

      <v-col v-for="(card, index) in serviceTypeCards" :key="index" cols="12" sm="6" md="4">
        <RouterLink :to="{ name: 'id-card', params: { id: card.id } }" class="text-decoration-none">
          <gridCard :title="card.title" :price="card.current_price" :subtitle="card.short_description"
            :image="getImage(card.image)" />
        </RouterLink>
      </v-col>
    </v-row>
  </v-container>
  <HowWork />
  <WhyUs />
  <Footer />
</template>
<script setup>
import { serviceIdCard } from '@/services/apiServices.js'
import { useRouter, useRoute } from 'vue-router';
import { ref, onMounted, watch } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Landing from '@/components/Landing.vue';
import gridCard from '@/components/resuable/gridCard.vue';
import HowWork from '@/components/HomeCompoent/HowWork.vue';
import WhyUs from '@/components/HomeCompoent/WhyUs.vue';
import Footer from '@/components/SharedUI/Footer.vue'
import { apiConfig } from "@/config/apiConfig";
import banner1 from "@/assets/images/administrator.jpg";
// import { cards } from '@/Store/data/cards.js'

// import { useCardStore } from '@/Store/cardStore';
// const cardStore = useCardStore();

// const router = useRouter();
const route = useRoute();
const cardIdFromRoute = parseInt(route.params.id);
const serviceTypeCards = ref([]);
const error = ref(null);


// const getImage = (item) => {
//   return item ? `${apiConfig.imageUrl}${item}` : banner1;
// }

import { getCurrentInstance } from 'vue';
const { appContext } = getCurrentInstance();
const getImage = appContext.config.globalProperties.$getImage;

const fetchServiceIdCard = async (cardIdFromRoute) => {
  // console.log(cardIdFromRoute, "cardIdFromRoute")
  try {
    const data = await serviceIdCard(cardIdFromRoute, null);
    serviceTypeCards.value = data;
  } catch (err) {
    error.value = err.response?.data?.message || "Failed to load services";
    console.error("Error fetching service details:", err);
  }
};


onMounted(() => {
  fetchServiceIdCard(parseInt(route.params.id));
});


// watch for id param change
watch(
  () => route.params.id,
  (newId) => {
    if (newId) {
      fetchServiceIdCard(parseInt(newId));
    }
  }
);

// const goToCardDetail = (id, title) => {
//   console.log(id, title, category);
//   router.push({ name: 'id-card', params: { id }, query: { title } });
// }

// function goToCardDetail(card) {
//   cardStore.selectedCard = card;
//   router.push({ name: 'id-card', params: { id: card.id } });
// }






</script>
